import {
  jb_play_pause_button_css_default
} from "./chunk.ZDDOIIVJ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n,
  r as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-play-pause-button/jb-play-pause-button.ts
var JbPlayPauseButton = class extends r {
  constructor() {
    super(...arguments);
    this.spriteSvgUrl = "";
    this._playing = false;
  }
  setMediaElement(mediaElement) {
    this._mediaElement = mediaElement;
    this._mediaElement.addEventListener("play", () => {
      this._playing = true;
    });
    this._mediaElement.addEventListener("pause", () => {
      this._playing = false;
    });
    this._mediaElement.addEventListener("ended", () => {
      this._playing = false;
    });
  }
  _click() {
    if (!this._mediaElement) {
      return;
    }
    this._playing = !this._playing;
    if (this._playing) {
      this._mediaElement.play();
    } else {
      this._mediaElement.pause();
    }
  }
  _renderPauseButton() {
    if (this.spriteSvgUrl) {
      return ke` <svg class="pause"><use href=${this.spriteSvgUrl + "#plyr-pause"}></use></svg> `;
    }
    return ke`
      <svg
        class="pause"
        viewBox="0 0 18 18"
      >
        <rect
          x="4.35"
          y="2"
          width="2.3"
          height="14"
          rx=".245"
        ></rect>
        <rect
          x="11.35"
          y="2"
          width="2.3"
          height="14"
          rx=".245"
        ></rect>
      </svg>
    `;
  }
  _renderPlayButton() {
    if (this.spriteSvgUrl) {
      return ke` <svg class="play"><use href=${this.spriteSvgUrl + "#plyr-play"}></use></svg> `;
    }
    return ke`
      <svg
        class="play"
        viewBox="0 0 18 18"
      >
        <path
          d="M13.308 9.192l-6.345 6.345a.271.271 0 01-.463-.192V2.655a.271.271 0 01.463-.192l6.345 6.345a.271.271 0 010 .384z"
        ></path>
      </svg>
    `;
  }
  render() {
    return ke`<button
      aria-label="${this._playing ? this.ariaLabelPause ?? "Pause" : this.ariaLabelPlay ?? "Play"}"
      aria-pressed="${this._playing ? "true" : "false"}"
      @click=${this._click}
      class=${Rt({ playing: this._playing })}
    >
      ${this._renderPlayButton()} ${this._renderPauseButton()}
    </button>`;
  }
};
JbPlayPauseButton.styles = jb_play_pause_button_css_default;
__decorateClass([
  n()
], JbPlayPauseButton.prototype, "ariaLabelPause", 2);
__decorateClass([
  n()
], JbPlayPauseButton.prototype, "ariaLabelPlay", 2);
__decorateClass([
  n()
], JbPlayPauseButton.prototype, "spriteSvgUrl", 2);
__decorateClass([
  r2()
], JbPlayPauseButton.prototype, "_playing", 2);
JbPlayPauseButton = __decorateClass([
  customElement("jb-play-pause-button")
], JbPlayPauseButton);

export {
  JbPlayPauseButton
};
